import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import * as action from './store/OprationalCP.action';
import * as userAction from '../UserSetting/store/User.action';
import * as systemMasterAction from '../SystemMasters/Store/SystemMasters.action';
import CommonMultiSelect from '../../Components/Utility/FilterAction/CommonMultiSelect';
import { YearsWithId, months } from '../../Components/helper';
import RowSection from './RowSection';
import './OprationalCP.css';
import ColumnSection from './ColumnSection';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import Loader from '../../Components/Utility/Loader/Loader';

function AddEditOprationalCP() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation('common');
  const { id } = useParams();
  const duplicateDetails = location?.state;
  const {
    SystemMastersDetails: {
      brandList,
      seasonList,
      category1List,
      category2List,
      pcTypeList,
      multipleCategory3,
      multipleCategory4,
      productStatusList,
      multiSubBrandList,
    },
    UserDetails: { userInfo },
    oprationalCPDetails: { supplierList, editData, cardRowsData, cardColmnsData },
  } = useSelector((reducer) => reducer);
  console.log('editData=========>', editData);
  const loggedInUserId = userInfo?.userId;
  const cat2Params = {
    accessedFrom: '',
    categoryType: 2,
    loggedInUserId,
    isActive: true,
  };
  const cat1Params = {
    accessedFrom: '',
    categoryType: 1,
    loggedInUserId,
    isActive: true,
  };
  const commonParam = {
    loggedInUserId,
    isActive: true,
  };
  const productCPParams = {
    isActive: true,
    tier: 'Tier1',
  };
  const [addEditState, setAddEditState] = useState({
    name: '',
    brand: [],
    subBrand: [],
    season: [],
    year: [],
    category1: [],
    category2: [],
    category3: [],
    category4: [],
    productType: [],
    suppliers: [],
    status: [],
    month: [],
    hasError: false,
    charCount: 0,
    isLoading: false,
    loading: false,
    Rows: [],
    Columns: [],
    selectedRows: [],
    selectedColumns: [],
    category3List: [],
    category4List: [],
    selectAllRows: false,
    selectAllcolumns: false,
    showRowModal: false,
    showColumnModal: false,
    editIndex: -1,
    editRowData: null,
    editColumnData: null,
    _id: '',
    isDragging: false,
    isColumnDragging: false,
    showDeleteConfirmation: false,
    deleteIndex: -1,
    fromModal: '',
  });

  const {
    name,
    brand,
    subBrand,
    season,
    year,
    category1,
    category2,
    category3,
    category4,
    productType,
    suppliers,
    status,
    month,
    hasError,
    charCount,
    loading,
    Rows,
    Columns,
  } = addEditState;
  const disableMultiSelect = duplicateDetails?.fromArchive || (!duplicateDetails?._id && editData);
  const [subBrandAccess, setSubBrandAccess] = useState(false);
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);

  useEffect(() => {
    const fetchLicensorAccess = async () => {
      const subBrandAccessRes = await dispatch(systemMasterAction.getSubBrandAccess());
      setSubBrandAccess(subBrandAccessRes?.data || false);
    };
    fetchLicensorAccess();
  }, [dispatch]);

  useEffect(() => {
    const fetchFlag = async () => {
      try {
        const res = await dispatch(systemMasterAction.getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchFlag();
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(addEditState?.brand)) {
      dispatch(systemMasterAction.getMultiSubBrandDetails({ brandId: addEditState.brand }));
    }
  }, [addEditState?.brand, dispatch]);
  // helper: normalize selection (ids or objects) to ids
  const normalizeIds = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val.map((v) => (typeof v === 'object' ? v?._id : v)).filter(Boolean);
    return [typeof val === 'object' ? val?._id : val].filter(Boolean);
  };

  useEffect(() => {
    if (!isEmpty(category1) && !isEmpty(category2)) {
      const callCategory3Api = async () => {
        const cat3params = {
          categoryOneId: normalizeIds(category1),
          categoryTwoId: normalizeIds(category2),
          categoryType: 3,
          loggedInUserId,
          isActive: true,
        };
        dispatch(systemMasterAction.clearMultipleReducer(['cat_3', 'cat_4']));
        dispatch(systemMasterAction.getMultipleCatgory(cat3params, false));
      };
      callCategory3Api();
    }
  }, [category1, category2, dispatch, loggedInUserId]);

  useEffect(() => {
    if (!isEmpty(category1) && !isEmpty(category2) && !isEmpty(category3)) {
      const callCategory4Api = async () => {
        const cat4params = {
          categoryOneId: normalizeIds(category1),
          categoryTwoId: normalizeIds(category2),
          categoryThreeId: normalizeIds(category3),
          categoryType: 4,
          loggedInUserId,
          isActive: true,
        };
        dispatch(systemMasterAction.clearMultipleReducer(['cat_4']));
        dispatch(systemMasterAction.getMultipleCatgory(cat4params));
      };
      callCategory4Api();
    }
  }, [category1, category2, category3, dispatch, loggedInUserId]);
  // added to solve the looping api calls for lastOpened
  useEffect(() => {
    const callFn = async () => {
      const lastOpenedParams = {
        modalId: id,
        userId: loggedInUserId,
        type: 'operationalCP',
      };
      dispatch(action.lastOpened(lastOpenedParams));
    };
    if (!duplicateDetails?._id && editData && loggedInUserId && id) {
      callFn();
    }
  }, [editData, duplicateDetails, loggedInUserId, id, dispatch]);

  useEffect(() => {
    if (id) {
      const callEditApi = async () => {
        setAddEditState((prevState) => ({ ...prevState, loading: true }));
        await Promise.all([
          dispatch(action.fetchEditData(id)),
          dispatch(action.getRowsForCard(id)),
          dispatch(action.getColumnsForCard(id)),
          dispatch(userAction.fetchUserGroupsCards()),
        ]);
        setAddEditState((prevState) => ({ ...prevState, loading: false }));
      };
      callEditApi();
    }
    const initialFunctions = async () => {
      setAddEditState((prevState) => ({ ...prevState, loading: true }));
      await Promise.all([
        dispatch(systemMasterAction.getBrandDetails()),
        dispatch(systemMasterAction.getSeasonsDetails(commonParam)),
        dispatch(systemMasterAction.getCategory1Details(cat1Params)),
        dispatch(systemMasterAction.getCategory2Details(cat2Params)),
        dispatch(systemMasterAction.getPCTypesDetails(productCPParams)),
        dispatch(action.fetchSuppliers()),
      ]);

      setAddEditState((prevState) => ({ ...prevState, loading: false })); // set res at the last api called for the modal
      dispatch(
        systemMasterAction.getProductStatusDetails({
          loggedInUserId: userInfo?.userId,
          isActive: 1,
        }),
      );
    };
    initialFunctions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch, loggedInUserId]);

  const checkNullInArrayIds = (array) => {
    return array?.filter((ele) => ele)?.map((e) => (typeof e === 'object' ? e?._id : e));
  };

  useEffect(() => {
    if (editData) {
      setAddEditState((oldState) => ({
        ...oldState,
        name: editData?.name,
        brand: checkNullInArrayIds(editData?.brand),
        subBrand: checkNullInArrayIds(editData?.subBrand),
        season: checkNullInArrayIds(editData?.season),
        month: editData?.month,
        year: editData?.year,
        // store full objects for categories
        category1: editData?.catOneId || [],
        category2: editData?.catTwoId || [],
        category3: editData?.catThreeId || [],
        category4: editData?.catFourId || [],
        productType: checkNullInArrayIds(editData?.productType),
        suppliers: checkNullInArrayIds(editData?.suppliers),
        status: editData?.status,
        charCount: editData?.name?.length,
        _id: editData?._id || '',
      }));
    } else if (duplicateDetails?._id) {
      setAddEditState((oldState) => ({
        ...oldState,
        name: duplicateDetails?.name,
        brand: checkNullInArrayIds(duplicateDetails?.brand),
        subBrand: checkNullInArrayIds(duplicateDetails?.subBrand),
        season: checkNullInArrayIds(duplicateDetails?.season),
        month: duplicateDetails?.month,
        year: duplicateDetails?.year,
        category1: duplicateDetails?.catOneId || [],
        category2: duplicateDetails?.catTwoId || [],
        category3: duplicateDetails?.catThreeId || [],
        category4: duplicateDetails?.catFourId || [],
        productType: checkNullInArrayIds(duplicateDetails?.productType),
        suppliers: checkNullInArrayIds(duplicateDetails?.suppliers),
        status: duplicateDetails?.status,
        charCount: duplicateDetails?.name?.length,
      }));
    }
  }, [editData, duplicateDetails]);

  useEffect(() => {
    if (!isEmpty(cardRowsData)) {
      setAddEditState((oldState) => ({
        ...oldState,
        Rows: [...cardRowsData],
      }));
    }
  }, [cardRowsData]);

  useEffect(() => {
    if (!isEmpty(cardColmnsData)) {
      setAddEditState((oldState) => ({
        ...oldState,
        Columns: [...cardColmnsData],
      }));
    }
  }, [cardColmnsData]);

  useEffect(() => {
    if (!isEmpty(multipleCategory3) && !isEmpty(category1) && !isEmpty(category2)) {
      setAddEditState((oldData) => ({
        ...oldData,
        category3List: [...multipleCategory3],
      }));
    }
    if (!isEmpty(multipleCategory4) && !isEmpty(category1) && !isEmpty(category2) && !isEmpty(category3)) {
      setAddEditState((oldData) => ({
        ...oldData,
        category4List: [...multipleCategory4],
      }));
    }
  }, [multipleCategory3, multipleCategory4, category1, category2, category3]);

  // Helpers + filtered lists (PIM-like)
  const toIds = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val.map((v) => (typeof v === 'object' ? v?._id : v)).filter(Boolean);
    return [typeof val === 'object' ? val?._id : val].filter(Boolean);
  };
  const extractIds = (list) => (Array.isArray(list) ? list.map((x) => x?._id).filter(Boolean) : []);
  const pruneToValid = (sel, valid) => (Array.isArray(sel) ? sel.filter((id) => valid.includes(id)) : []);

  const selPT = toIds(addEditState?.productType);
  const selC1 = toIds(addEditState?.category1);
  const selC2 = toIds(addEditState?.category2);
  const selC3 = toIds(addEditState?.category3);

  const filteredC1 = useMemo(() => {
    if (!catBasedOnPTData) return category1List;
    if (!selPT.length) return [];
    return (category1List || []).filter((c1) => {
      const rel = c1?.productType || [];
      const arr = Array.isArray(rel) ? rel : [rel];
      return arr.some((id) => selPT.includes(id?._id || id));
    });
  }, [catBasedOnPTData, category1List, selPT]);

  const filteredC2 = useMemo(() => {
    if (!catBasedOnPTData) return category2List;
    if (!selC1.length) return [];
    return (category2List || []).filter((c2) => {
      const rel = c2?.categoryOneId || c2?.catOneIds || [];
      const arr = Array.isArray(rel) ? rel : [rel];
      return arr.some((id) => selC1.includes(id?._id || id));
    });
  }, [catBasedOnPTData, category2List, selC1]);

  const filteredC3 = useMemo(() => {
    if (!catBasedOnPTData) return multipleCategory3;
    if (!selC1.length || !selC2.length) return [];
    return (multipleCategory3 || []).filter((c3) => {
      const r1 = c3?.categoryOneId || c3?.catOneIds || [];
      const r2 = c3?.categoryTwoId || c3?.catTwoIds || [];
      const a1 = Array.isArray(r1) ? r1 : [r1];
      const a2 = Array.isArray(r2) ? r2 : [r2];
      const ok1 = a1.some((id) => selC1.includes(id?._id || id));
      const ok2 = a2.some((id) => selC2.includes(id?._id || id));
      return ok1 && ok2;
    });
  }, [catBasedOnPTData, multipleCategory3, selC1, selC2]);

  const filteredC4 = useMemo(() => {
    if (!catBasedOnPTData) return multipleCategory4;
    if (!selC1.length || !selC2.length || !selC3.length) return [];
    return (multipleCategory4 || []).filter((c4) => {
      const r1 = c4?.categoryOneId || c4?.catOneIds || [];
      const r2 = c4?.categoryTwoId || c4?.catTwoIds || [];
      const r3 = c4?.categoryThreeId || c4?.catThreeIds || [];
      const a1 = Array.isArray(r1) ? r1 : [r1];
      const a2 = Array.isArray(r2) ? r2 : [r2];
      const a3 = Array.isArray(r3) ? r3 : [r3];
      const ok1 = a1.some((id) => selC1.includes(id?._id || id));
      const ok2 = a2.some((id) => selC2.includes(id?._id || id));
      const ok3 = a3.some((id) => selC3.includes(id?._id || id));
      return ok1 && ok2 && ok3;
    });
  }, [catBasedOnPTData, multipleCategory4, selC1, selC2, selC3]);

  // map selected ids to objects from current options
  const mapIdsToObjects = (list, ids) => {
    if (!Array.isArray(list)) return [];
    const idSet = new Set(ids);
    return list.filter((item) => idSet.has(item?._id));
  };

  const getOptionsForKey = (key) => {
    switch (key) {
      case 'category1':
        return catBasedOnPTData ? filteredC1 : category1List;
      case 'category2':
        return catBasedOnPTData ? filteredC2 : category2List;
      case 'category3':
        return catBasedOnPTData ? filteredC3 : multipleCategory3;
      case 'category4':
        return catBasedOnPTData ? filteredC4 : multipleCategory4;
      default:
        return [];
    }
  };

  const handleSelect = (val, key) => {
    if (!catBasedOnPTData) {
      // store objects for categories; productType stays as ids
      if (['category1', 'category2', 'category3', 'category4'].includes(key)) {
        const objs = mapIdsToObjects(getOptionsForKey(key), normalizeIds(val));
        setAddEditState((other) => ({ ...other, [key]: objs }));
        return;
      }
      onChange(val, key === 'productType' ? 'Product Type' : key);
      return;
    }
    setAddEditState((prev) => {
      const next = { ...prev };
      if (key === 'productType') {
        // set new PT
        next.productType = [...val];
        const newPTIds = toIds(val);
        // if PT cleared, clear all categories explicitly
        if (!newPTIds.length) {
          next.category1 = [];
          next.category2 = [];
          next.category3 = [];
          next.category4 = [];
          return next;
        }
        // compute valid Category 1 from NEW PT
        const validC1Options = (category1List || []).filter((c1) => {
          const rel = c1?.productType || [];
          const arr = Array.isArray(rel) ? rel : [rel];
          return arr.some((rid) => newPTIds.includes(rid?._id || rid));
        });
        next.category1 = pruneToValid(toIds(next.category1), extractIds(validC1Options));

        // compute valid Category 2 from pruned Cat 1
        const validC2Options = (category2List || []).filter((c2) => {
          const rel = c2?.categoryOneId || c2?.catOneIds || [];
          const arr = Array.isArray(rel) ? rel : [rel];
          return arr.some((rid) => toIds(next.category1).includes(rid?._id || rid));
        });
        next.category2 = pruneToValid(toIds(next.category2), extractIds(validC2Options));

        // compute valid Category 3 from pruned Cat 1 + Cat 2
        const validC3Options = (multipleCategory3 || []).filter((c3) => {
          const r1 = c3?.categoryOneId || c3?.catOneIds || [];
          const r2 = c3?.categoryTwoId || c3?.catTwoIds || [];
          const a1 = Array.isArray(r1) ? r1 : [r1];
          const a2 = Array.isArray(r2) ? r2 : [r2];
          const ok1 = a1.some((rid) => toIds(next.category1).includes(rid?._id || rid));
          const ok2 = a2.some((rid) => toIds(next.category2).includes(rid?._id || rid));
          return ok1 && ok2;
        });
        next.category3 = pruneToValid(toIds(next.category3), extractIds(validC3Options));

        // compute valid Category 4 from pruned Cat 1 + Cat 2 + Cat 3
        const validC4Options = (multipleCategory4 || []).filter((c4) => {
          const r1 = c4?.categoryOneId || c4?.catOneIds || [];
          const r2 = c4?.categoryTwoId || c4?.catTwoIds || [];
          const r3 = c4?.categoryThreeId || c4?.catThreeIds || [];
          const a1 = Array.isArray(r1) ? r1 : [r1];
          const a2 = Array.isArray(r2) ? r2 : [r2];
          const a3 = Array.isArray(r3) ? r3 : [r3];
          const ok1 = a1.some((rid) => toIds(next.category1).includes(rid?._id || rid));
          const ok2 = a2.some((rid) => toIds(next.category2).includes(rid?._id || rid));
          const ok3 = a3.some((rid) => toIds(next.category3).includes(rid?._id || rid));
          return ok1 && ok2 && ok3;
        });
        next.category4 = pruneToValid(toIds(next.category4), extractIds(validC4Options));
      }
      if (key === 'category1') {
        next.category1 = mapIdsToObjects(getOptionsForKey('category1'), normalizeIds(val));
        const v2 = extractIds(filteredC2);
        next.category2 = mapIdsToObjects(getOptionsForKey('category2'), pruneToValid(toIds(next.category2), v2));
        const v3 = extractIds(filteredC3);
        next.category3 = mapIdsToObjects(getOptionsForKey('category3'), pruneToValid(toIds(next.category3), v3));
        const v4 = extractIds(filteredC4);
        next.category4 = mapIdsToObjects(getOptionsForKey('category4'), pruneToValid(toIds(next.category4), v4));
      }
      if (key === 'category2') {
        next.category2 = mapIdsToObjects(getOptionsForKey('category2'), normalizeIds(val));
        const v3 = extractIds(filteredC3);
        next.category3 = mapIdsToObjects(getOptionsForKey('category3'), pruneToValid(toIds(next.category3), v3));
        const v4 = extractIds(filteredC4);
        next.category4 = mapIdsToObjects(getOptionsForKey('category4'), pruneToValid(toIds(next.category4), v4));
      }
      if (key === 'category3') {
        next.category3 = mapIdsToObjects(getOptionsForKey('category3'), normalizeIds(val));
        const v4 = extractIds(filteredC4);
        next.category4 = mapIdsToObjects(getOptionsForKey('category4'), pruneToValid(toIds(next.category4), v4));
      }
      if (key === 'category4') {
        next.category4 = mapIdsToObjects(getOptionsForKey('category4'), normalizeIds(val));
      }
      return next;
    });
  };

  const redirectToListingPage = async () => {
    dispatch(action.clearReducer());
    dispatch(systemMasterAction.clearMultipleReducer(['cat_3', 'cat_4']));
    history.push({
      pathname: '/operational-cp',
    });
  };

  const redirectToEditPage = (redirectId) => {
    history.push({
      pathname: `/operational-cp/create/${redirectId}`,
    });
  };

  const onChange = (e, changeName) => {
    switch (changeName) {
      case 'cpName':
        setAddEditState((otherState) => ({
          ...otherState,
          name: e,
          charCount: e.length,
          hasError: false,
        }));
        break;
      case 'Brand':
        setAddEditState((otherState) => ({
          ...otherState,
          brand: [...e],
        }));
        break;
      case 'Sub Brand':
        setAddEditState((otherState) => ({
          ...otherState,
          subBrand: [...e],
        }));
        break;
      case 'Month':
        setAddEditState((otherState) => ({
          ...otherState,
          month: [...e],
        }));
        break;
      case 'Season':
        setAddEditState((otherState) => ({
          ...otherState,
          season: [...e],
        }));
        break;
      case 'Year':
        setAddEditState((otherState) => ({
          ...otherState,
          year: [...e],
        }));
        break;
      case 'Category 1':
        setAddEditState((otherState) => ({
          ...otherState,
          category1: [...e],
          category3: [],
          category4: [],
          category3List: [],
          category4List: [],
        }));
        break;
      case 'Categories 2':
        setAddEditState((otherState) => ({
          ...otherState,
          category2: [...e],
          category3: [],
          category4: [],
          category3List: [],
          category4List: [],
        }));
        break;
      case 'Categories 3':
        setAddEditState((otherState) => ({
          ...otherState,
          category3: [...e],
          category4: [],
          category4List: [],
        }));
        break;
      case 'Categories 4':
        setAddEditState((otherState) => ({
          ...otherState,
          category4: [...e],
        }));
        break;
      case 'Product Type':
        setAddEditState((otherState) => ({
          ...otherState,
          productType: [...e],
        }));
        break;
      case 'Status':
        setAddEditState((otherState) => ({
          ...otherState,
          status: [...e],
        }));
        break;
      default:
        setAddEditState((otherState) => ({
          ...otherState,
          suppliers: [...e],
        }));
        break;
    }
  };

  const checkingNonNullValues = (array) => {
    return array?.filter((ele) => ele);
  };

  const onSubmitMethod = async () => {
    if (name?.length > 0) {
      if (duplicateDetails?._id) {
        const params = {
          name: name?.trim(),
          season: checkingNonNullValues(season),
          year,
          productType: checkingNonNullValues(productType),
          brand: checkingNonNullValues(brand),
          subBrand: checkingNonNullValues(subBrand),
          month,
          catOneId: normalizeIds(category1),
          catTwoId: normalizeIds(category2),
          catThreeId: normalizeIds(category3),
          catFourId: normalizeIds(category4),
          suppliers: checkingNonNullValues(suppliers),
          status,
          rows: Rows,
          columns: Columns,
        };
        const res = await dispatch(action.duplicateOperationalCP(params, t));
        if (res) {
          dispatch(action.fetchEditData(id));
          redirectToEditPage(res);
        }
      } else {
        const params = {
          name: name?.trim(),
          season: checkingNonNullValues(season),
          year,
          productType: checkingNonNullValues(productType),
          brand: checkingNonNullValues(brand),
          subBrand: checkingNonNullValues(subBrand),
          month,
          catOneId: normalizeIds(category1),
          catTwoId: normalizeIds(category2),
          catThreeId: normalizeIds(category3),
          catFourId: normalizeIds(category4),
          suppliers: checkingNonNullValues(suppliers),
          status,
        };
        if (id) {
          params._id = id;
        }
        const res = await dispatch(action.addCard(params, t));
        if (res) {
          dispatch(action.fetchEditData(id || res));
          redirectToEditPage(res);
        }
      }
    } else {
      setAddEditState((otherState) => ({
        ...otherState,
        hasError: true,
      }));
    }
  };

  const addRow = () => {
    setAddEditState((oldState) => ({
      ...oldState,
      showRowModal: true,
      editIndex: -1,
      editRowData: null,
    }));
  };

  const addColumn = () => {
    setAddEditState((oldState) => ({
      ...oldState,
      showColumnModal: true,
      editIndex: -1,
      editColumnData: null,
    }));
  };

  const deleteRow = async (index) => {
    setAddEditState((oldState) => ({
      ...oldState,
      deleteIndex: index,
      showDeleteConfirmation: true,
      fromModal: 'Row',
      selectAllRows: false,
    }));
  };

  const rowDeleteConfirmed = async () => {
    if (addEditState.deleteIndex !== -1) {
      if (addEditState.deleteIndex === null) {
        const params = {
          operationalId: id,
          rowIds: [...addEditState.selectedRows],
        };
        const res = await dispatch(action.deleteRowsCard(params, t));
        if (res) {
          const currentRows = [...addEditState.Rows];
          const newRows = currentRows.filter((element) => !addEditState.selectedRows.includes(element?._id));
          setAddEditState((oldState) => ({
            ...oldState,
            Rows: newRows,
            deleteIndex: -1,
            showDeleteConfirmation: false,
            fromModal: '',
          }));
        }
      } else {
        const params = {
          operationalId: id,
          rowIds: [addEditState.deleteIndex],
        };

        const response = await dispatch(action.deleteRowsCard(params, t));
        if (response) {
          const currentRows = [...addEditState.Rows];
          const findIndex = currentRows.findIndex((e) => e?._id === addEditState.deleteIndex);
          currentRows.splice(findIndex, 1);
          setAddEditState((oldState) => ({
            ...oldState,
            Rows: currentRows,
            deleteIndex: -1,
            showDeleteConfirmation: false,
            fromModal: '',
          }));
        }
      }
    }
  };

  const deleteColumn = async (index) => {
    setAddEditState((oldState) => ({
      ...oldState,
      deleteIndex: index,
      showDeleteConfirmation: true,
      fromModal: 'Column',
      selectAllColumns: false,
    }));
  };

  const toggleDeleteConfirmed = async () => {
    setAddEditState((oldState) => ({
      ...oldState,
      deleteIndex: -1,
      showDeleteConfirmation: false,
      fromModal: '',
    }));
  };

  const columnDeleteConfirmed = async () => {
    if (addEditState.deleteIndex === null) {
      const params = {
        operationalId: id,
        columnIds: [...addEditState.selectedColumns],
      };
      const res = await dispatch(action.deleteColumnsCard(params, t));
      if (res) {
        const currentColumns = [...addEditState.Columns];
        const newColumns = currentColumns.filter((element) => !addEditState.selectedColumns.includes(element?._id));
        setAddEditState((oldState) => ({
          ...oldState,
          Columns: newColumns,
          deleteIndex: -1,
          showDeleteConfirmation: false,
          fromModal: '',
        }));
      }
    } else {
      const params = {
        operationalId: id,
        columnIds: [addEditState.deleteIndex],
      };
      const response = await dispatch(action.deleteColumnsCard(params, t));
      if (response) {
        const currentColumns = [...addEditState.Columns];
        const findIndex = currentColumns.findIndex((e) => e?._id === addEditState.deleteIndex);
        currentColumns.splice(findIndex, 1);
        setAddEditState((oldState) => ({
          ...oldState,
          Columns: currentColumns,
          deleteIndex: -1,
          showDeleteConfirmation: false,
          fromModal: '',
        }));
      }
    }
  };

  const handleEdit = (i) => {
    setAddEditState((oldState) => ({
      ...oldState,
      editIndex: i,
      editRowData: addEditState.Rows[i],
      showRowModal: true,
    }));
  };

  const handleColumnEdit = (i) => {
    setAddEditState((oldState) => ({
      ...oldState,
      editIndex: i,
      editColumnData: addEditState.Columns[i],
      showColumnModal: true,
    }));
  };

  const handleSelectAllRows = (e) => {
    setAddEditState((oldState) => ({
      ...oldState,
      selectAllRows: e?.target?.checked,
      selectedRows: e?.target?.checked ? addEditState.Rows.map((ele) => ele?._id) : [],
    }));
  };

  const handleSelectAllColumns = (e) => {
    setAddEditState((oldState) => ({
      ...oldState,
      selectAllColumns: e?.target?.checked,
      selectedColumns: e?.target?.checked ? addEditState.Columns.map((ele) => ele?._id) : [],
    }));
  };

  const onSelectCheckBox = (e, id) => {
    let selectedItems = [...addEditState.selectedRows];
    if (e.target.checked) {
      setAddEditState((oldState) => ({
        ...oldState,
        selectedRows: [...selectedItems, id],
        selectAllRows: addEditState.Rows?.length === [...selectedItems, id].length,
      }));
    } else {
      selectedItems = selectedItems.filter((item) => item !== id);
      setAddEditState((oldState) => ({
        ...oldState,
        selectAllRows: false,
        selectedRows: [...selectedItems],
      }));
    }
  };

  const onSelectColumnCheckBox = (e, id) => {
    let selectedItems = [...addEditState.selectedColumns];
    if (e.target.checked) {
      setAddEditState((oldState) => ({
        ...oldState,
        selectedColumns: [...selectedItems, id],
        selectAllColumns: addEditState.Columns?.length === [...selectedItems, id].length,
      }));
    } else {
      selectedItems = selectedItems.filter((item) => item !== id);
      setAddEditState((oldState) => ({
        ...oldState,
        selectAllColumns: false,
        selectedColumns: [...selectedItems],
      }));
    }
  };

  const closeRowModal = async () => {
    setAddEditState((oldState) => ({
      ...oldState,
      showRowModal: false,
      editIndex: -1,
      editRowData: null,
    }));
    await dispatch(action.getRowsForCard(id));
  };

  const closeColumnModal = async () => {
    setAddEditState((oldState) => ({
      ...oldState,
      showColumnModal: false,
      editIndex: -1,
      editColumnData: null,
    }));
    await dispatch(action.getColumnsForCard(id));
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (addEditState.isColumnDragging && !isEmpty(addEditState.Columns)) {
        setAddEditState((prevCards) => ({
          ...prevCards,
          isColumnDragging: false,
        }));
        const newSequence = [];
        addEditState.Columns.forEach((element, index) => {
          newSequence.push({ _id: element?._id, sequence: index });
        });
        const insertObj = {
          columns: [...newSequence],
          _id: id,
          fromMovingCards: true,
        };
        // moving cards
        dispatch(action.addColumnsToCard(insertObj, t));
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [dispatch, addEditState.isColumnDragging, addEditState.Columns, id, t]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (addEditState.isDragging && !isEmpty(addEditState.Rows)) {
        setAddEditState((prevCards) => ({
          ...prevCards,
          isDragging: false,
        }));
        const newSequence = [];
        addEditState.Rows.forEach((element, index) => {
          newSequence.push({ _id: element?._id, sequence: index });
        });
        const insertObj = {
          rows: [...newSequence],
          _id: id,
          fromMovingCards: true,
        };
        // moving cards
        dispatch(action.addRowsToCard(insertObj, t));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [dispatch, addEditState.isDragging, addEditState.Rows, id, t]);

  return loading ? (
    <Loader />
  ) : (
    <>
      <div className="page-title-filter sticky mb-3">
        <div className="title-container d-flex align-items-center">
          <div className="title-floating fixed-label">
            <input
              type="text"
              name="oprationalCriticalPathName"
              placeholder="Enter Operational Critical Path Name"
              value={name}
              className="form-control text-bordered w-300 h-30 f-14 ml-1"
              maxLength={30}
              disabled={duplicateDetails?.fromArchive}
              onChange={(e) => onChange(e?.target?.value, 'cpName')}
            />
            <div className="text-count d-none d-md-flex f-14">{charCount}/30</div>
            {hasError && !name && <span className="error-message px-2">{t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.NAME_REQUIRED')}</span>}
          </div>
        </div>
        <div className="search-filter action-new-row">
          <div className="custom-File-Button">
            <button
              type="button"
              className="btn btn-white ml-2"
              onClick={onSubmitMethod}
              disabled={duplicateDetails?.fromArchive || duplicateDetails?.name === name}
            >
              <i className="icon-Save mr-1" />
              {t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.SAVE')}
            </button>
          </div>
          <button type="button" className="btn btn-white btn-back-lib" onClick={redirectToListingPage}>
            {t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.BACK')}
          </button>
        </div>
      </div>
      <Container fluid>
        <Row className="pt-2 row-col-5">
          <Col lg={3} className="mb-3">
            <CommonMultiSelect
              label={t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.BRAND')}
              onChange={onChange}
              selectedValue={addEditState.brand}
              optionList={brandList}
              selectLabel="name"
              selectValue="_id"
              disable={disableMultiSelect}
            />
          </Col>
          {subBrandAccess && (
            <Col lg={3} className="mb-3">
              <CommonMultiSelect
                label="Sub Brand"
                onChange={onChange}
                selectedValue={addEditState?.subBrand}
                optionList={multiSubBrandList?.filter((ele) => ele?.isActive)}
                selectLabel="name"
                selectValue="_id"
                disable={disableMultiSelect}
              />
            </Col>
          )}
          <Col lg={3} className="mb-3">
            <CommonMultiSelect
              label={t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.SEASON')}
              onChange={onChange}
              selectedValue={addEditState.season}
              optionList={seasonList}
              selectLabel="name"
              selectValue="_id"
              disable={disableMultiSelect}
            />
          </Col>
          <Col lg={3} className="mb-3">
            <CommonMultiSelect
              label={t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.MONTH')}
              onChange={onChange}
              selectedValue={addEditState.month}
              optionList={months} // yearList
              selectLabel="name"
              selectValue="_id"
              disable={disableMultiSelect}
            />
          </Col>
          <Col lg={3} className="mb-3">
            <CommonMultiSelect
              label={t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.YEAR')}
              onChange={onChange}
              selectedValue={addEditState.year}
              optionList={YearsWithId()} // yearList
              selectLabel="name"
              selectValue="_id"
              disable={disableMultiSelect}
              scrollToCurrentYear
            />
          </Col>
          <Col lg={3} className="mb-3">
            <CommonMultiSelect
              label={t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.PRODUCT_TYPE')}
              onChange={(val) => handleSelect(val, 'productType')}
              selectedValue={addEditState.productType}
              optionList={pcTypeList}
              selectLabel="name"
              selectValue="_id"
              disable={disableMultiSelect}
            />
          </Col>
          {console.log('addEditState3333333333333', addEditState)}
          <Col lg={3} className="mb-3">
            <CommonMultiSelect
              label={t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.CATEGO0RY_1')}
              onChange={(val) => handleSelect(val, 'category1')}
              selectedValue={addEditState.category1}
              optionList={catBasedOnPTData ? filteredC1 : category1List}
              selectLabel="name"
              selectValue="_id"
              disable={disableMultiSelect}
            />
          </Col>
          <Col lg={3} className="mb-3">
            <CommonMultiSelect
              label={t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.CATEGORIES_2')}
              onChange={(val) => handleSelect(val, 'category2')}
              selectedValue={addEditState.category2}
              optionList={catBasedOnPTData ? filteredC2 : category2List}
              selectLabel="name"
              selectValue="_id"
              disable={disableMultiSelect}
            />
          </Col>
          <Col lg={3} className="mb-3">
            <CommonMultiSelect
              label={t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.CATEGORIES_3')}
              onChange={(val) => handleSelect(val, 'category3')}
              selectedValue={addEditState.category3}
              optionList={catBasedOnPTData ? filteredC3 : addEditState.category3List}
              selectLabel="name"
              selectValue="_id"
              disable={disableMultiSelect}
            />
          </Col>
          <Col lg={3} className="mb-3">
            <CommonMultiSelect
              label={t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.CATEGORIES_4')}
              onChange={(val) => handleSelect(val, 'category4')}
              selectedValue={addEditState.category4}
              optionList={catBasedOnPTData ? filteredC4 : addEditState.category4List}
              selectLabel="name"
              selectValue="_id"
              disable={disableMultiSelect}
            />
          </Col>

          <Col lg={3} className="mb-3">
            <CommonMultiSelect
              label={t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.SUPPLIERS')}
              onChange={onChange}
              selectedValue={addEditState.suppliers}
              optionList={supplierList}
              selectLabel="name"
              selectValue="_id"
              disable={disableMultiSelect}
            />
          </Col>
          <Col lg={3} className="mb-3">
            <CommonMultiSelect
              label={t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.STATUS')}
              onChange={onChange}
              selectedValue={addEditState.status}
              optionList={productStatusList}
              selectLabel="name"
              selectValue="_id"
              disable={disableMultiSelect}
            />
          </Col>
        </Row>
        {id && (
          <RowSection
            isProductArchived={duplicateDetails?.fromArchive}
            addRow={addRow}
            deleteRow={deleteRow}
            editState={addEditState}
            handleSelectAllRows={handleSelectAllRows}
            onSelectCheckBox={onSelectCheckBox}
            handleEdit={handleEdit}
            closeRowModal={closeRowModal}
            isName={duplicateDetails?._id || duplicateDetails?.fromArchive}
            setAddEditState={setAddEditState}
          />
        )}
        {id && (
          <div className="pt-3">
            <ColumnSection
              isProductArchived={duplicateDetails?.fromArchive}
              addColumn={addColumn}
              deleteColumn={deleteColumn}
              editState={addEditState}
              handleSelectAllColumns={handleSelectAllColumns}
              onSelectCheckBox={onSelectColumnCheckBox}
              handleEdit={handleColumnEdit}
              closeColumnModal={closeColumnModal}
              isName={duplicateDetails?._id || duplicateDetails?.fromArchive}
              setAddEditState={setAddEditState}
            />
          </div>
        )}
        {addEditState.showDeleteConfirmation && (
          <ConfirmationPopup
            onOpen={addEditState.showDeleteConfirmation}
            onConfirm={addEditState.fromModal === 'Column' ? columnDeleteConfirmed : rowDeleteConfirmed}
            title={`${t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.DELETE')} ${addEditState.fromModal}`}
            message={`${t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.ARE_U_SURE_DELETE')} ${addEditState.fromModal}${t(
              'OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.(S)',
            )}`}
            secondMessage={`${t('OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.ACTION_CAN_NOT_READ')} ${addEditState.fromModal} ${t(
              'OPERATIONAL_CP.ADD_EDIT_OPRATIONAL_CP.WOULD_BE_DELETED',
            )}`}
            toggle={toggleDeleteConfirmed}
            showCheckBox
            loading={addEditState.isLoading}
          />
        )}
      </Container>
    </>
  );
}

export default AddEditOprationalCP;
